<template>
  <aside class="m-message-bar m-message-bar--alert">
    <slot />
  </aside>
</template>

<style lang="scss" scoped>
.m-message-bar {
  justify-content: center;
}
</style>
